/**
 * Default order for meal types (matches backend dictionary and mobile apps).
 * Use when ordering slots, building empty cells, or when API does not specify order.
 */
export const DEFAULT_MEAL_TYPE_ORDER = [
  'breakfast',
  'lunch',
  'dinner',
  'snack',
  'brunch',
  'tea',
  'supper',
  'early_morning',
  'pre_breakfast',
  'post_breakfast',
  'pre_lunch',
  'post_lunch',
  'evening_snack',
  'high_tea',
  'post_dinner',
  'midnight_snack',
] as const;

/** Default time for each meal type in default order (HH:mm). Used when initializing slots. */
export const DEFAULT_MEAL_TIMES: readonly string[] = [
  '09:00', '13:00', '20:00', '15:00', '11:00', '10:30', '19:00', '06:00', '07:00', '10:00', '12:00', '14:00', '17:00', '16:00', '21:00', '22:00',
];

/** Build a map of meal key -> sort index from default order (unknown keys get high index). */
export function mealOrderMap(): Record<string, number> {
  const map: Record<string, number> = {};
  DEFAULT_MEAL_TYPE_ORDER.forEach((k, i) => {
    map[k] = i;
  });
  return map;
}
